import _mixin from '../_mixin'

export default {
  name: 'SCommercialLottery',
  cnName: '商业化抽奖活动',
  type: 'activity_other',
  preview: 'https://rescdn.ssjj.cn/website/2024/05/17/1f251f33e8d30b965516cb67201f8eda.jpg',
  // 属性相关
  props: {
    part1Top: '570px', // 累计消费-活动1位置
    part1Obj: [
      {
        bgWidth: '1360px',
        bgHeight: '510px',
        imgWidth: '213px',
        imgHeight: '303px',
        priceColor: '#FFCC00',
        textColor: '#ffffff',
        textFont: '24px',
        tipsPositionTop: '-320px',
        btnTextFont: '40px'
      }
    ],
    part1Btn: [
      {
        btnWidth: '274px',
        btnHeight: '78px'
      }
    ],

    part2Top: '1500px', // 特惠礼包-活动2位置

    part2Obj: [
      {
        bgWidth: '1430px',
        bgHeight: '810px',
        itemWidth: '460px',
        itemHeight: '490px',
        btnTextFont: '40px',
        lotteryTitle: 'https://rescdn.ssjj.cn/website/2024/10/09/aa84b021946b0d9c25a989d57720018f.png',
        lotteryTitleWidth: '286px',
        lotteryTitleHeight: '67px'
      }
    ],
    part2Btn: [
      {
        btnSrc: 'https://rescdn.ssjj.cn/website/2024/10/09/471593397c3997aa5f79730bcf91eee8.png',
        btnWidth: '274px',
        btnHeight: '78px',
        bigBtnWidth: '516px',
        bigBtnHeight: '111px'
      }
    ],

    part3Top: '2720px', // 奖池一览-活动3位置

    part3Obj: [
      {
        bgWidth: '1335px',
        bgHeight: '586px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2024/10/11/882576a1308245ec801890266be51b3f.png',
        itemWidth: '234px',
        itemHeight: '227px',
        padding: '50px 21px',
        btnTextFont: '40px'
      }
    ],
    part3Btn: [
      {
        btnWidth: '274px',
        btnHeight: '78px'
      }
    ],

    part4Top: '4050px', // 积分兑换-活动4位置
    part4Obj: [
      {
        bgWidth: '1335px',
        bgHeight: '720px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2024/10/11/882576a1308245ec801890266be51b3f.png',
        itemWidth: '234px',
        itemHeight: '234px',
        padding: '0 30px 0 30px',
        btnTextFont: '24px',
        tipFont: '24px',
        tipColor: '#ffffff'
      }
    ],
    part4Btn: [
      {
        btnWidth: '234px',
        btnHeight: '67px'
      }
    ],

    packageInfo: [
      {
        btnSrc: 'https://rescdn.ssjj.cn/website/2024/11/05/9d3342d22e6acdcd37eb1a30a5963d54.png',
        btnGreySrc: 'https://rescdn.ssjj.cn/website/2024/11/07/7f129300cd21d6dd3523bf2642ab3de2.png'
      }
    ],
    mainHeight: '4416px',
    bg: {
      src: 'https://rescdn.ssjj.cn/website/2024/10/09/3544e099f4a82ba99dd72dd73b67e32c.jpg'
    },
    // ===== 活动 ID 配置 =====
    activityId1: 'FRK5JJHBR7LUJKBNT4WHSKBUQM',
    activityId2: 'ODDVH7YUACYCHDK7XPEUDMZ5BI',
    activityId3: 'HV6IMKNPMYZEKUTDNPXWVS3K5E',
    activityId4: 'W627DYLTMPR2QODXYZ6I3FQ2QA',
    // ===== text color =====
    textColorLevel1: '#333',
    textColorLevel2: '#666',
    textColorLevel3: '#999',
    textColorActive: '#FFCC00',
    miniBtnColor: '#ffffff',

    // ===== 领取按钮 =====
    // 未开始按钮
    receiveBtn0: {
      src: 'https://rescdn.ssjj.cn/website/2024/10/09/471593397c3997aa5f79730bcf91eee8.png'
    },
    // 未完成按钮
    receiveBtn1: {
      src: 'https://rescdn.ssjj.cn/website/2024/10/09/471593397c3997aa5f79730bcf91eee8.png'
    },
    // 领取按钮
    receiveBtn2: {
      src: 'https://rescdn.ssjj.cn/website/2024/10/09/471593397c3997aa5f79730bcf91eee8.png'
    },
    // 已领取按钮
    receiveBtn3: {
      src: 'https://rescdn.ssjj.cn/website/2024/05/17/07ad6dacffe1694a0f3f2497dff3cde9.png'
    },
    // 已过期按钮
    receiveBtn4: {
      src: 'https://rescdn.ssjj.cn/website/2024/05/17/96466c62a8fdfc9289e818cfc06b2981.png'
    },
    // 弹窗相关
    modalBg: {
      src: 'https://rescdn.ssjj.cn/website/2024/11/07/3f75467a43af2d149b068f22fb3d8264.jpg',
      style: {
        width: '1000px',
        height: '850px'
      }
    },
    modalCloseIcon: {
      src: 'https://rescdn.ssjj.cn/website/2024/03/13/f76e2285005d4f4cdc20b79f15a87f5b.png',
      style: {
        width: '54px',
        height: '42px',
        right: '-60px',
        top: '0px'
      }
    },
    modalTitleStyle: '{"color": "#A81548", "opacity": "0.8", "font-weight": "700"}',
    modalTextStyle: '{"color": "#ffffff"}',
    modalConfirmBtnStyle: '{"background-image":"url(https://rescdn.ssjj.cn/website/2024/03/15/99b4684fb700b34aa5da97b1024be328.png)","color": "#FFF", "font-weight": "700"}',
    modalCancelBtnStyle: '{"background-image":"url(https://rescdn.ssjj.cn/website/2024/03/15/b4c489022fc32a83793352f2e4d29c78.png)","color": "#FFF", "font-weight": "700"}'
  },
  propsDesc: [
    {
      target: 'part1Top',
      label: '累计消费定位'
    },
    {
      target: 'part1Obj',
      label: '累计消费配置',
      formType: 'list',
      listConfig: [
        {
          title: '容器宽度',
          target: 'bgWidth'
        },
        {
          title: '容器高度',
          target: 'bgHeight'
        },
        {
          title: '内容图片宽度',
          target: 'imgWidth'
        },
        {
          title: '内容图片高度',
          target: 'imgHeight'
        },
        {
          title: '消费点券颜色',
          target: 'priceColor'
        },
        {
          title: '文本颜色',
          target: 'textColor'
        },
        {
          title: '文本大小',
          target: 'textFont'
        },
        {
          title: '累计消费点数top位置',
          target: 'tipsPositionTop'
        },
        {
          title: '按钮文本大小',
          target: 'btnTextFont'
        }
      ]
    },
    {
      target: 'part1Btn',
      label: '累计消费按钮配置',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        }
      ]
    },
    {
      target: 'part2Top',
      label: '特惠礼包定位'
    },
    {
      target: 'part2Obj',
      label: '特惠礼包配置',
      formType: 'list',
      listConfig: [
        {
          title: '容器宽度',
          target: 'bgWidth'
        },
        {
          title: '容器高度',
          target: 'bgHeight'
        },
        {
          title: '物品图宽度',
          target: 'itemWidth'
        },
        {
          title: '物品图高度',
          target: 'itemHeight'
        },
        {
          title: '按钮文字大小',
          target: 'btnTextFont'
        },
        {
          title: '抽奖券购买标题',
          target: 'lotteryTitle'
        },
        {
          title: '抽奖券标题宽度',
          target: 'lotteryTitleWidth'
        },
        {
          title: '抽奖券标题高度',
          target: 'lotteryTitleHeight'
        }
      ]
    },
    {
      target: 'part2Btn',
      label: '特惠礼包按钮配置',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '抽奖券按钮宽度',
          target: 'bigBtnWidth'
        },
        {
          title: '抽奖券按钮高度',
          target: 'bigBtnHeight'
        },
        {
          title: '按钮地址',
          target: 'btnSrc'
        }
      ]
    },
    {
      target: 'part3Top',
      label: '奖池一览活动定位'
    },
    {
      target: 'part3Obj',
      label: '奖池一览配置',
      formType: 'list',
      listConfig: [
        {
          title: '容器宽度',
          target: 'bgWidth'
        },
        {
          title: '容器高度',
          target: 'bgHeight'
        },
        {
          title: '图片背景链接',
          target: 'bgSrc'
        },
        {
          title: '物品图宽度',
          target: 'itemWidth'
        },
        {
          title: '物品图高度',
          target: 'itemHeight'
        },
        {
          title: '容器间距',
          target: 'padding'
        },
        {
          title: '按钮文本大小',
          target: 'btnTextFont'
        }
      ]
    },
    {
      target: 'part3Btn',
      label: '奖池一览按钮配置',
      formType: 'list',
      listConfig: [
        {
          title: '按钮宽度',
          target: 'btnWidth'
        },
        {
          title: '按钮高度',
          target: 'btnHeight'
        }
      ]
    },
    {
      target: 'part4Top',
      label: '积分兑换定位'
    },
    {
      target: 'part4Obj',
      label: '积分兑换活动配置',
      formType: 'list',
      listConfig: [
        {
          title: '背景图片宽度',
          target: 'bgWidth'
        },
        {
          title: '背景图片高度',
          target: 'bgHeight'
        },
        {
          title: '图片背景链接',
          target: 'bgSrc'
        },
        {
          title: '物品图宽度',
          target: 'itemWidth'
        },
        {
          title: '物品图高度',
          target: 'itemHeight'
        },
        {
          title: '提示文字大小',
          target: 'tipFont'
        },
        {
          title: '提示文字颜色',
          target: 'tipColor'
        },
        {
          title: '容器间距',
          target: 'padding'
        }
      ]
    },
    {
      target: 'part4Btn',
      label: '积分兑换按钮配置',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'bgSrc'
        },
        {
          title: '再抽X次背景链接',
          target: 'textBgSrc'
        },
        {
          title: '再抽X次文字色值',
          target: 'textColor'
        },
        {
          title: '抽奖文字颜色',
          target: 'btnTextColor'
        }
      ]
    },
    {
      target: 'packageInfo',
      label: '背包列表配置',
      formType: 'list',
      listConfig: [
        {
          title: '按钮背景',
          target: 'btnSrc'
        },
        {
          title: '置灰按钮背景',
          target: 'btnGreySrc'
        }
      ]
    },
    {
      target: 'mainHeight',
      label: '主体高度(除头部)'
    },
    {
      target: 'bg',
      label: '背景图',
      formType: 'image'
    },
    {
      target: '=== 活动 ID 配置 ===',
      formType: 'divider'
    },
    {
      target: 'activityId1',
      label: '点券累消领取'
    },
    {
      target: 'activityId2',
      label: '购买抽奖券'
    },
    {
      target: 'activityId3',
      label: '抽奖'
    },
    {
      target: 'activityId4',
      label: '分解积分兑换'
    },
    {
      target: '公共文本颜色',
      formType: 'divider'
    },
    {
      target: 'textColorLevel1',
      label: '一级文本颜色',
      formType: 'color'
    },
    {
      target: 'textColorLevel2',
      label: '二级文本颜色',
      formType: 'color'
    },
    {
      target: 'textColorLevel3',
      label: '三级文本颜色',
      formType: 'color'
    },
    {
      target: 'textColorActive',
      label: '活跃文本颜色',
      formType: 'color'
    },
    {
      target: 'miniBtnColor',
      label: '小按钮颜色',
      formType: 'color'
    },

    {
      target: '---补给商店列表---',
      formType: 'divider'
    },
    {
      target: 'shopList',
      label: '购买物品列表',
      formType: 'list',
      listConfig: [
        {
          title: '物品图',
          target: 'awardImg'
        },
        {
          title: '按钮图',
          target: 'btnImg'
        }
      ]
    },
    {
      target: '--抽奖相关--',
      formType: 'divider'
    },
    // {
    //   target: 'drawActiveItem',
    //   label: '高亮显示项'
    // },
    {
      target: '-----领取按钮-----',
      formType: 'divider'
    },
    {
      target: 'receiveBtn0',
      label: '未开始按钮',
      formType: 'image'
    },
    {
      target: 'receiveBtn1',
      label: '未完成按钮',
      formType: 'image'
    },
    {
      target: 'receiveBtn2',
      label: '领取按钮',
      formType: 'image'
    },
    {
      target: 'receiveBtn3',
      label: '已领取按钮',
      formType: 'image'
    },
    {
      target: 'receiveBtn4',
      label: '已过期按钮',
      formType: 'image'
    },
    {
      target: '===== 公共弹窗 ======',
      formType: 'divider'
    },
    {
      target: 'modalBg',
      label: '弹窗背景图',
      formType: 'image'
    },
    {
      target: 'modalCloseIcon',
      label: '关闭按钮',
      formType: 'image'
    },
    {
      target: 'modalTitleStyle',
      label: '标题样式',
      formType: 'textarea'
    },
    {
      target: 'modalTextStyle',
      label: '文本样式',
      formType: 'textarea'
    },
    {
      target: 'modalConfirmBtnStyle',
      label: '确认按钮样式',
      formType: 'textarea'
    },
    {
      target: 'modalCancelBtnStyle',
      label: '取消按钮样式',
      formType: 'textarea'
    }

  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ],
  children: [
    // {
    //   id: genId() + '_BaseGroup_0',
    //   ...BaseGroup
    // },
    // {
    //   id: genId() + '_BaseGroup_1',
    //   ...BaseGroup
    // }
  ]
}
